/**
 * ANOTAR QUE SE MIRÓ ESTA PANTALLA, para que el globito del inicio baje.
 *
 * Javier: «cuando hay memes nuevos o partidos nuevos poner un círculo en rojo
 * la cantidad de cosas nuevas que hayan para que los usuarios abran los
 * accesos rápidos». El globito solo sirve si se APAGA al entrar: uno que
 * siempre está encendido es uno que la gente aprende a ignorar.
 *
 * ES UN GANCHO Y NO CUATRO EFECTOS COPIADOS. Son cuatro pantallas con la misma
 * necesidad, y copiado se convierte en tres que se actualizan y una que no.
 *
 * SE ANOTA AL ENTRAR Y UNA SOLA VEZ, no al salir: ver `anotarVisita`. Sin
 * sesión no se anota nada — la llave lleva el id de la persona adentro, porque
 * dos cuentas en la misma tablet no comparten lo que cada una miró.
 */
import { useEffect } from 'react';

import { useAuth } from '../auth/AuthContext';
import { anotarVisita, type Pantalla } from '../lib/visitas';

export function useAnotarVisita(pantalla: Pantalla): void {
  const { session } = useAuth();
  const miId = session?.user.id;

  useEffect(() => {
    if (miId === undefined) return;
    anotarVisita(miId, pantalla);
  }, [miId, pantalla]);
}
